import { useState, useEffect } from "react";
import API from "../api";
import http from "../network/http";

function useRemoteKeyValueStore(key, defaultValue, getMapper, setMapper, onErrorReturn) {
  const [value, setValue] = useState(defaultValue);
  const [isInit, setIsInit] = useState(false);

  // 获取服务器上的视图配置
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.fetch(`${API.url}/keyValue?key=${key}`);
        if (response.ok) {
          const json = await response.json();
          console.log(`key=${key}, value=${JSON.stringify(json)}`);
          if (json.code === 0) {
            setValue(getMapper ? getMapper(json.value) : json.value);
          } else if (onErrorReturn) {
            setValue(onErrorReturn());
          }
        }
      } catch (error) {
        console.log("get key value error:" + error);
      }
    };

    fetchData();
  }, [key]);

  function updateValueToRemote(value) {
    const postData = async () => {
      try {
        console.log(`set key:${key}, value: ${value}`);
        await http.fetch(`${API.url}/keyValue`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            key: key,
            value: setMapper ? setMapper(value) : value,
          }),
        });
      } catch (error) {
        console.log("post key value error: " + error);
      }
    };
    postData();
  }

  useEffect(() => {
    if (isInit) {
      updateValueToRemote(value);
    } else {
      setIsInit(true);
    }
  }, [value]);

  return [value, setValue];
}

export default useRemoteKeyValueStore;
